import { createSelector } from '@ngrx/store';
import { irGeneratorFeature } from './ir-generator.reducer';

export const { selectQueries, selectNextId, selectIrGeneratorState } =
  irGeneratorFeature;

export const selectCanAddQuery = createSelector(selectQueries, (queries) => {
  const lastQuery = queries[queries.length - 1];
  return (
    !!lastQuery &&
    !!lastQuery.prompt.trim() &&
    !lastQuery.isLoading &&
    !lastQuery.error
  );
});
